import BaseApi from '../base/base'
import AsForm from '../../forms/as';
import { RequestMode } from '../api_constant';
import Question from '../../models/question';

export default class AsApi extends BaseApi {
  constructor () {
    super()
    this.path = '/as'
  }

  async create (params : AsForm, mode = RequestMode.DETAIL) : Promise<Question[]>{
    this.path = '/as'
    const response = await this.postRequest({...params, mode})
    return response.data.map((element) => {
      return new Question(element)
    })
  }

  async aiGrade (asIds: number[], examId: any, qId: any, userExamId: any) : Promise<Question[]>{
    this.path = '/as/ai_grade'
    const response = await this.postRequest({asIds, examId, qId, userExamId})
    return response.data.map((element) => {
      return new Question(element)
    })
  }
}
